//*************************DO NOT MODIFY**************************
//
//THESE FILES ARE AUTOGENERATED WITH TYPEWRITER AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//PLEASE VISIT http://frhagn.github.io/Typewriter/ TO LEARN MORE ABOUT THIS VISUAL STUDIO EXTENSION
//
//*************************DO NOT MODIFY**************************
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MediaModel } from '../models/MediaModel';
import { TypeMediaModel } from '../models/TypeMediaModel';
import { MediaViewModel } from '../models/MediaViewModel';

@Injectable({
  providedIn: 'root',
})
export class MediaApiService {
  constructor(private _httpClient: HttpClient) {}

  // get: api/Media/getMedia?id=${id}
  getMedia(id: number): Observable<MediaModel> {
    var _Url = `api/Media/getMedia?id=${id}`;
    return this._httpClient.get<MediaModel>(_Url).pipe(catchError(this.handleError));
  }

  // post: api/Media/saveMediaForType?mediaTypeId=${mediaTypeId}&mediaId=${mediaId}
  saveMediaForType(mediaTypeId: number, mediaId: number): Observable<boolean> {
    var _Url = `api/Media/saveMediaForType?mediaTypeId=${mediaTypeId}&mediaId=${mediaId}`;
    return this._httpClient.post<boolean>(_Url, mediaTypeId).pipe(catchError(this.handleError));
  }

  // get: api/Media/getMediasForType?typeMedia=${typeMedia}
  getMediasForType(typeMedia: number): Observable<MediaModel[]> {
    var _Url = `api/Media/getMediasForType?typeMedia=${typeMedia}`;
    return this._httpClient.get<MediaModel[]>(_Url).pipe(catchError(this.handleError));
  }

  // get: api/Media/getTypeMedia?id=${id}
  getTypeMedia(id: number): Observable<TypeMediaModel> {
    var _Url = `api/Media/getTypeMedia?id=${id}`;
    return this._httpClient.get<TypeMediaModel>(_Url).pipe(catchError(this.handleError));
  }

  // post: api/Media?mediaType=${mediaType}&isTemp=${isTemp}
  uploadMedia(mediaType: number, isTemp: boolean): Observable<MediaViewModel> {
    var _Url = `api/Media?mediaType=${mediaType}&isTemp=${isTemp}`;
    return this._httpClient.post<MediaViewModel>(_Url, mediaType).pipe(catchError(this.handleError));
  }

  // Utility
  private handleError(error: HttpErrorResponse) {
    console.error(error);
    let customError: string = '';
    if (error.error) {
      customError = error.status === 400 ? error.error : error.statusText;
    }
    return throwError(customError || 'Server error');
  }
}
